<sl-title [title]="pageTitle"></sl-title>
<mat-card class="linq-card--legacy">
	<sl-filters [config]="filterConfig" [options]="filterOptions" [fields]="filterFields" [filters]="filters" [showChipKey]="true"
		[disableFilters]="tableHasSelections" (filtersUpdated)="applyFilter($event)">
	</sl-filters>
	<sl-table [data]="data" [config]="config" [filters]="filters" [noDataText]="noDataMessage"></sl-table>
</mat-card>
<sl-form [form]="form" [fields]="formFields" [model]="updateModel" [options]="formOptions" (submitted)="onSubmit($event)" [flyoutTitle]="formTitle"
	[editOnly]="true"></sl-form>
